import { render, staticRenderFns } from "./StudiKasus.vue?vue&type=template&id=77cc76b2&"
import script from "./StudiKasus.vue?vue&type=script&lang=js&"
export * from "./StudiKasus.vue?vue&type=script&lang=js&"
import style0 from "./StudiKasus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports